export const IMPORT_CUSTOMER_INIT_ACTION = 'IMPORT_CUSTOMER_INIT_ACTION';
export const IMPORT_CUSTOMER_SUCCES_ACTION = IMPORT_CUSTOMER_INIT_ACTION + '_SUCCESS';
export const IMPORT_CUSTOMER_FAIL_ACTION = IMPORT_CUSTOMER_INIT_ACTION+"_ERROR";